import { useEffect, useState } from 'react';

interface SmoothValueUpdateOptions {
  initialValue?: number;
  targetValue: number;
  interval?: number;
  delay?: number;
}

const useSmoothValueUpdate = ({
  initialValue = 0,
  targetValue,
  interval = 50,
  delay = 0,
}: SmoothValueUpdateOptions) => {
  const [animatedProgress, setAnimatedProgress] =
    useState<number>(initialValue);
  const [isDelaying, setIsDelaying] = useState<boolean>(delay > 0);

  useEffect(() => {
    let targetValueInterval: NodeJS.Timeout | null = null;
    let timeoutId: NodeJS.Timeout;

    const updateProgress = () => {
      setAnimatedProgress(currentProgress => {
        const nextProgress = currentProgress + 1;
        if (nextProgress >= targetValue) {
          clearInterval(targetValueInterval as NodeJS.Timeout);
          return targetValue;
        }
        return nextProgress;
      });
    };

    if (delay > 0) {
      timeoutId = setTimeout(() => {
        setIsDelaying(false);
        targetValueInterval = setInterval(updateProgress, interval);
      }, delay);
    } else {
      setIsDelaying(false);
      targetValueInterval = setInterval(updateProgress, interval);
    }

    return () => {
      clearInterval(targetValueInterval as NodeJS.Timeout);
      clearTimeout(timeoutId);
    };
  }, [targetValue, interval, delay]);

  return isDelaying ? 0 : animatedProgress;
};

export default useSmoothValueUpdate;
